import { render, staticRenderFns } from "./RedPacketSettings.vue?vue&type=template&id=114b214a&scoped=true"
import script from "./RedPacketSettings.vue?vue&type=script&lang=js"
export * from "./RedPacketSettings.vue?vue&type=script&lang=js"
import style0 from "./RedPacketSettings.vue?vue&type=style&index=0&id=114b214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b214a",
  null
  
)

export default component.exports